module.exports = __webpack_public_path__ + "media/images/emblems/Monteceneri_CoA-364907af1d3c9345c48e1cce9001ca0d.png";